import script from "./SaemitalkTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaemitalkTitle.vue?vue&type=script&setup=true&lang=ts"

import "./SaemitalkTitle.vue?vue&type=style&index=0&id=24d6e8f2&lang=css"

const __exports__ = script;

export default __exports__